export const USED_BONUS_REPORT_PT_BR = {
	usedBonus: "Bonus Utilizados",
	columns: {
		client: "Cliente",
		givenAt: "Concedido em",
		consumedAt: "Utilizado em",
		reason: "Motivo",
		spentValueInBonus: "Valor do Pagamento em Bônus",
		total: "Total",
	},
};

export type UsedBonusReportTranslations = typeof USED_BONUS_REPORT_PT_BR;
